import request from '@/utils/request'
// import md5 from "js-md5"
// blast 任务接口参数
export function blastParams(url) {
    return request({
        url: '/mongo/blast_params',
        method: 'get',
        // params:data,//get请求参数
    })
}
//jbrowse
export function jbrowse(url) {
    return request({
        url: '/mongo/jbrowse',
        method: 'get',
        // params:data,//get请求参数
    })
}
//SNP例子
export function example(data) {
    return request({
        url: '/mongo/func_eg',
        method: 'get',
        params:data,//get请求参数
    })
}
export function getSearch(url,param) {
    return request({
        url: url,
        method: 'get',
        params: param,
    })
}
//SNP
export function SNPseek(url,param) {
    return request({
        url: url,
        method: 'get',
        params: param,
    })
}

export function getFasta(url,data) {
    return request({
        url: url,
        method: 'post',
        data,
    })
}
//pathway
export function map(url,data) {
    return request({
        url: '/mongo/map/',
        method: 'post',
        data,
    })
}
//tools-RepeatMasker
export function te_rm(url,data) {
    return request({
        url: '/mongo/te_rm/',
        method: 'post',
        data,
    })
}
//tools-RepeatProteinMask
export function te_rpm(url,data) {
    return request({
        url: '/mongo/te_rpm/',
        method: 'post',
        data,
    })
}